import { Badge, BadgeData, BadgeStatus } from "../types/badges";

// ─── Badge Definitions ───────────────────────────────────────────────────────

export const BADGES: Badge[] = [
  // ── General / Login ──────────────────────────────────────────────────────
  {
    id: "first_login",
    title: "Hello World!",
    description: "Log in for the first time — everyone starts somewhere",
    icon: "fa-solid fa-hand-sparkles",
    category: "general",
    rarity: "common",
  },
  {
    id: "login_3_streak",
    title: "Three-peat",
    description: "Log in 3 days in a row",
    icon: "fa-solid fa-fire",
    category: "general",
    rarity: "common",
  },
  {
    id: "login_7_streak",
    title: "Week Warrior",
    description: "Log in every day for a full week",
    icon: "fa-solid fa-calendar-week",
    category: "general",
    rarity: "uncommon",
  },
  {
    id: "login_14_streak",
    title: "Fortnight Force",
    description: "Two solid weeks of daily logins",
    icon: "fa-solid fa-shield-halved",
    category: "general",
    rarity: "rare",
  },
  {
    id: "login_30_streak",
    title: "Monthly Master",
    description: "30-day login streak — absolute dedication",
    icon: "fa-solid fa-calendar-check",
    category: "general",
    rarity: "epic",
  },
  {
    id: "login_100_streak",
    title: "Unstoppable",
    description: "100-day login streak. Are you even human?",
    icon: "fa-solid fa-infinity",
    category: "general",
    rarity: "legendary",
  },
  {
    id: "logins_50",
    title: "Regular",
    description: "Log in 50 times total",
    icon: "fa-solid fa-mug-hot",
    category: "general",
    rarity: "uncommon",
  },
  {
    id: "logins_100",
    title: "Century Club",
    description: "100 total logins — you really live here",
    icon: "fa-solid fa-couch",
    category: "general",
    rarity: "rare",
  },
  {
    id: "logins_365",
    title: "Year-Round",
    description: "365 total logins — a whole year's worth",
    icon: "fa-solid fa-earth-europe",
    category: "general",
    rarity: "epic",
  },
  {
    id: "logins_500",
    title: "Login Legend",
    description: "500 logins. This app is basically your home",
    icon: "fa-solid fa-house-chimney",
    category: "general",
    rarity: "legendary",
  },
  {
    id: "night_owl",
    title: "Night Owl",
    description: "Been on the app for over 30 days — you're a regular now",
    icon: "fa-solid fa-moon",
    category: "general",
    rarity: "uncommon",
  },
  {
    id: "old_timer",
    title: "Old Timer",
    description: "Your account is over 6 months old",
    icon: "fa-solid fa-hourglass-half",
    category: "general",
    rarity: "rare",
  },
  {
    id: "anniversary",
    title: "Happy Birthday!",
    description: "One year on OnyxLife. Cake not included",
    icon: "fa-solid fa-cake-candles",
    category: "general",
    rarity: "epic",
  },

  // ── Tasks ────────────────────────────────────────────────────────────────
  {
    id: "first_task",
    title: "Getting Started",
    description: "Create your very first task",
    icon: "fa-solid fa-plus-circle",
    category: "tasks",
    rarity: "common",
  },
  {
    id: "task_done_1",
    title: "Done Deal",
    description: "Complete your first task. Feels good, right?",
    icon: "fa-solid fa-circle-check",
    category: "tasks",
    rarity: "common",
  },
  {
    id: "task_done_10",
    title: "On a Roll",
    description: "Complete 10 tasks",
    icon: "fa-solid fa-list-check",
    category: "tasks",
    rarity: "uncommon",
  },
  {
    id: "task_done_50",
    title: "Productivity Machine",
    description: "50 tasks completed — you're crushing it",
    icon: "fa-solid fa-robot",
    category: "tasks",
    rarity: "rare",
  },
  {
    id: "task_done_100",
    title: "Centurion",
    description: "100 tasks done. You should teach a masterclass",
    icon: "fa-solid fa-medal",
    category: "tasks",
    rarity: "epic",
  },
  {
    id: "task_done_500",
    title: "Task Titan",
    description: "500 completed tasks. Absolute legend",
    icon: "fa-solid fa-mountain-sun",
    category: "tasks",
    rarity: "legendary",
  },
  {
    id: "tasks_created_25",
    title: "Planner",
    description: "Create 25 tasks — you've got plans",
    icon: "fa-solid fa-clipboard-list",
    category: "tasks",
    rarity: "uncommon",
  },
  {
    id: "tasks_created_100",
    title: "Master Planner",
    description: "100 tasks created. You love making lists",
    icon: "fa-solid fa-diagram-project",
    category: "tasks",
    rarity: "rare",
  },

  // ── Notes ────────────────────────────────────────────────────────────────
  {
    id: "first_note",
    title: "Dear Diary",
    description: "Write your first note",
    icon: "fa-solid fa-pen-to-square",
    category: "notes",
    rarity: "common",
  },
  {
    id: "notes_10",
    title: "Noteworthy",
    description: "Write 10 notes",
    icon: "fa-solid fa-book-open",
    category: "notes",
    rarity: "uncommon",
  },
  {
    id: "notes_50",
    title: "Prolific Writer",
    description: "50 notes — you've got a lot to say",
    icon: "fa-solid fa-feather-pointed",
    category: "notes",
    rarity: "rare",
  },
  {
    id: "notes_100",
    title: "Novelist",
    description: "100 notes. That's basically a book",
    icon: "fa-solid fa-book",
    category: "notes",
    rarity: "epic",
  },

  // ── Fitness ──────────────────────────────────────────────────────────────
  {
    id: "first_workout",
    title: "Gym Rat",
    description: "Complete your first workout session",
    icon: "fa-solid fa-dumbbell",
    category: "fitness",
    rarity: "common",
  },
  {
    id: "first_lift",
    title: "Pump Iron",
    description: "Log your first lift entry",
    icon: "fa-solid fa-weight-hanging",
    category: "fitness",
    rarity: "common",
  },
  {
    id: "workouts_10",
    title: "Iron Will",
    description: "Complete 10 workout sessions",
    icon: "fa-solid fa-fire-flame-curved",
    category: "fitness",
    rarity: "uncommon",
  },
  {
    id: "workouts_25",
    title: "Dedicated Lifter",
    description: "25 workout sessions in the books",
    icon: "fa-solid fa-bolt",
    category: "fitness",
    rarity: "rare",
  },
  {
    id: "workouts_50",
    title: "Beast Mode",
    description: "50 workouts. The gym knows your name",
    icon: "fa-solid fa-dragon",
    category: "fitness",
    rarity: "epic",
  },
  {
    id: "workouts_100",
    title: "Iron Legend",
    description: "100 workout sessions. You are the gym",
    icon: "fa-solid fa-crown",
    category: "fitness",
    rarity: "legendary",
  },
  {
    id: "volume_1000",
    title: "One Tonne Club",
    description: "Lift 1,000 kg in total volume",
    icon: "fa-solid fa-truck-monster",
    category: "fitness",
    rarity: "uncommon",
  },
  {
    id: "volume_10000",
    title: "Ten Tonne Titan",
    description: "10,000 kg total volume lifted",
    icon: "fa-solid fa-building",
    category: "fitness",
    rarity: "rare",
  },
  {
    id: "volume_100000",
    title: "Hundred Tonne Hero",
    description: "100,000 kg. You could lift a house",
    icon: "fa-solid fa-city",
    category: "fitness",
    rarity: "epic",
  },
  {
    id: "volume_1000000",
    title: "Million Kilo Monster",
    description: "1,000,000 kg total. Officially superhuman",
    icon: "fa-solid fa-explosion",
    category: "fitness",
    rarity: "legendary",
  },
  {
    id: "first_cardio",
    title: "Cardio Starter",
    description: "Log your first cardio activity",
    icon: "fa-solid fa-heart-pulse",
    category: "fitness",
    rarity: "common",
  },
  {
    id: "first_weigh_in",
    title: "Stepping On",
    description: "Log your first body weight entry",
    icon: "fa-solid fa-scale-balanced",
    category: "fitness",
    rarity: "common",
  },
  {
    id: "lifts_100",
    title: "Rep Counter",
    description: "100 individual lift entries logged",
    icon: "fa-solid fa-arrow-up-1-9",
    category: "fitness",
    rarity: "rare",
  },
  {
    id: "lifts_500",
    title: "Set for Life",
    description: "500 lift entries. The data doesn't lie",
    icon: "fa-solid fa-chart-line",
    category: "fitness",
    rarity: "epic",
  },

  // ── Community ────────────────────────────────────────────────────────────
  {
    id: "first_post",
    title: "Hello Everyone!",
    description: "Make your first community post",
    icon: "fa-solid fa-comment-dots",
    category: "community",
    rarity: "common",
  },
  {
    id: "posts_10",
    title: "Regular Poster",
    description: "Share 10 community posts",
    icon: "fa-solid fa-comments",
    category: "community",
    rarity: "uncommon",
  },
  {
    id: "posts_50",
    title: "Community Pillar",
    description: "50 posts — everyone knows you here",
    icon: "fa-solid fa-landmark",
    category: "community",
    rarity: "rare",
  },
  {
    id: "posts_100",
    title: "Community Legend",
    description: "100 posts. You basically run this place",
    icon: "fa-solid fa-scroll",
    category: "community",
    rarity: "epic",
  },

  // ── Social ───────────────────────────────────────────────────────────────
  {
    id: "first_family",
    title: "Family First",
    description: "Add your first family member",
    icon: "fa-solid fa-people-roof",
    category: "social",
    rarity: "common",
  },
  {
    id: "referral",
    title: "Ambassador",
    description: "Refer a friend to OnyxLife",
    icon: "fa-solid fa-user-plus",
    category: "social",
    rarity: "uncommon",
  },
  {
    id: "first_list",
    title: "List Maker",
    description: "Create your first list",
    icon: "fa-solid fa-rectangle-list",
    category: "social",
    rarity: "common",
  },
  {
    id: "first_daily_log",
    title: "Self Care",
    description: "Log your first daily health entry",
    icon: "fa-solid fa-spa",
    category: "social",
    rarity: "common",
  },
  {
    id: "daily_logs_30",
    title: "Wellness Warrior",
    description: "30 daily health logs — you're in tune with your body",
    icon: "fa-solid fa-heart-circle-check",
    category: "social",
    rarity: "rare",
  },
  {
    id: "daily_logs_100",
    title: "Health Hero",
    description: "100 health logs. Your future self thanks you",
    icon: "fa-solid fa-staff-snake",
    category: "social",
    rarity: "epic",
  },

  // ── Account ──────────────────────────────────────────────────────────────
  {
    id: "early_adopter",
    title: "OG",
    description: "An early adopter of OnyxLife. Respect",
    icon: "fa-solid fa-seedling",
    category: "account",
    rarity: "legendary",
  },
  {
    id: "beta_pioneer",
    title: "Beta Pioneer",
    description: "Joined OnyxLife as a beta tester. Trailblazer!",
    icon: "fa-solid fa-flask-vial",
    category: "account",
    rarity: "epic",
  },
  {
    id: "premium",
    title: "VIP",
    description: "Subscribe to OnyxLife Pro",
    icon: "fa-solid fa-gem",
    category: "account",
    rarity: "rare",
  },
  {
    id: "theme_picker",
    title: "Stylist",
    description: "Customise your app theme",
    icon: "fa-solid fa-palette",
    category: "account",
    rarity: "common",
  },
  {
    id: "custom_nav",
    title: "My Way",
    description: "Customise your navigation bar",
    icon: "fa-solid fa-sliders",
    category: "account",
    rarity: "common",
  },
];

// ─── Badge Evaluation ────────────────────────────────────────────────────────

type EvalFn = (data: BadgeData) => { unlocked: boolean; progress?: number; progressLabel?: string };

const EVALUATORS: Record<string, EvalFn> = {
  // General / Login
  first_login: (d) => ({ unlocked: d.loginCount >= 1, progress: Math.min(1, d.loginCount / 1), progressLabel: `${Math.min(d.loginCount, 1)} / 1` }),
  login_3_streak: (d) => ({ unlocked: d.longestLoginStreak >= 3, progress: Math.min(1, d.longestLoginStreak / 3), progressLabel: `${Math.min(d.longestLoginStreak, 3)} / 3` }),
  login_7_streak: (d) => ({ unlocked: d.longestLoginStreak >= 7, progress: Math.min(1, d.longestLoginStreak / 7), progressLabel: `${Math.min(d.longestLoginStreak, 7)} / 7` }),
  login_14_streak: (d) => ({ unlocked: d.longestLoginStreak >= 14, progress: Math.min(1, d.longestLoginStreak / 14), progressLabel: `${Math.min(d.longestLoginStreak, 14)} / 14` }),
  login_30_streak: (d) => ({ unlocked: d.longestLoginStreak >= 30, progress: Math.min(1, d.longestLoginStreak / 30), progressLabel: `${Math.min(d.longestLoginStreak, 30)} / 30` }),
  login_100_streak: (d) => ({ unlocked: d.longestLoginStreak >= 100, progress: Math.min(1, d.longestLoginStreak / 100), progressLabel: `${Math.min(d.longestLoginStreak, 100)} / 100` }),
  logins_50: (d) => ({ unlocked: d.loginCount >= 50, progress: Math.min(1, d.loginCount / 50), progressLabel: `${Math.min(d.loginCount, 50)} / 50` }),
  logins_100: (d) => ({ unlocked: d.loginCount >= 100, progress: Math.min(1, d.loginCount / 100), progressLabel: `${Math.min(d.loginCount, 100)} / 100` }),
  logins_365: (d) => ({ unlocked: d.loginCount >= 365, progress: Math.min(1, d.loginCount / 365), progressLabel: `${Math.min(d.loginCount, 365)} / 365` }),
  logins_500: (d) => ({ unlocked: d.loginCount >= 500, progress: Math.min(1, d.loginCount / 500), progressLabel: `${Math.min(d.loginCount, 500)} / 500` }),
  night_owl: (d) => ({ unlocked: d.daysOnApp >= 30, progress: Math.min(1, d.daysOnApp / 30), progressLabel: `${Math.min(d.daysOnApp, 30)} / 30 days` }),
  old_timer: (d) => ({ unlocked: d.daysOnApp >= 180, progress: Math.min(1, d.daysOnApp / 180), progressLabel: `${Math.min(d.daysOnApp, 180)} / 180 days` }),
  anniversary: (d) => ({ unlocked: d.daysOnApp >= 365, progress: Math.min(1, d.daysOnApp / 365), progressLabel: `${Math.min(d.daysOnApp, 365)} / 365 days` }),

  // Tasks
  first_task: (d) => ({ unlocked: d.taskCount >= 1, progress: Math.min(1, d.taskCount / 1), progressLabel: `${Math.min(d.taskCount, 1)} / 1` }),
  task_done_1: (d) => ({ unlocked: d.tasksCompleted >= 1, progress: Math.min(1, d.tasksCompleted / 1), progressLabel: `${Math.min(d.tasksCompleted, 1)} / 1` }),
  task_done_10: (d) => ({ unlocked: d.tasksCompleted >= 10, progress: Math.min(1, d.tasksCompleted / 10), progressLabel: `${Math.min(d.tasksCompleted, 10)} / 10` }),
  task_done_50: (d) => ({ unlocked: d.tasksCompleted >= 50, progress: Math.min(1, d.tasksCompleted / 50), progressLabel: `${Math.min(d.tasksCompleted, 50)} / 50` }),
  task_done_100: (d) => ({ unlocked: d.tasksCompleted >= 100, progress: Math.min(1, d.tasksCompleted / 100), progressLabel: `${Math.min(d.tasksCompleted, 100)} / 100` }),
  task_done_500: (d) => ({ unlocked: d.tasksCompleted >= 500, progress: Math.min(1, d.tasksCompleted / 500), progressLabel: `${Math.min(d.tasksCompleted, 500)} / 500` }),
  tasks_created_25: (d) => ({ unlocked: d.taskCount >= 25, progress: Math.min(1, d.taskCount / 25), progressLabel: `${Math.min(d.taskCount, 25)} / 25` }),
  tasks_created_100: (d) => ({ unlocked: d.taskCount >= 100, progress: Math.min(1, d.taskCount / 100), progressLabel: `${Math.min(d.taskCount, 100)} / 100` }),

  // Notes
  first_note: (d) => ({ unlocked: d.noteCount >= 1, progress: Math.min(1, d.noteCount / 1), progressLabel: `${Math.min(d.noteCount, 1)} / 1` }),
  notes_10: (d) => ({ unlocked: d.noteCount >= 10, progress: Math.min(1, d.noteCount / 10), progressLabel: `${Math.min(d.noteCount, 10)} / 10` }),
  notes_50: (d) => ({ unlocked: d.noteCount >= 50, progress: Math.min(1, d.noteCount / 50), progressLabel: `${Math.min(d.noteCount, 50)} / 50` }),
  notes_100: (d) => ({ unlocked: d.noteCount >= 100, progress: Math.min(1, d.noteCount / 100), progressLabel: `${Math.min(d.noteCount, 100)} / 100` }),

  // Fitness
  first_workout: (d) => ({ unlocked: d.workoutSessions >= 1, progress: Math.min(1, d.workoutSessions / 1), progressLabel: `${Math.min(d.workoutSessions, 1)} / 1` }),
  first_lift: (d) => ({ unlocked: d.liftEntries >= 1, progress: Math.min(1, d.liftEntries / 1), progressLabel: `${Math.min(d.liftEntries, 1)} / 1` }),
  workouts_10: (d) => ({ unlocked: d.workoutSessions >= 10, progress: Math.min(1, d.workoutSessions / 10), progressLabel: `${Math.min(d.workoutSessions, 10)} / 10` }),
  workouts_25: (d) => ({ unlocked: d.workoutSessions >= 25, progress: Math.min(1, d.workoutSessions / 25), progressLabel: `${Math.min(d.workoutSessions, 25)} / 25` }),
  workouts_50: (d) => ({ unlocked: d.workoutSessions >= 50, progress: Math.min(1, d.workoutSessions / 50), progressLabel: `${Math.min(d.workoutSessions, 50)} / 50` }),
  workouts_100: (d) => ({ unlocked: d.workoutSessions >= 100, progress: Math.min(1, d.workoutSessions / 100), progressLabel: `${Math.min(d.workoutSessions, 100)} / 100` }),
  volume_1000: (d) => ({ unlocked: d.totalVolumeKg >= 1000, progress: Math.min(1, d.totalVolumeKg / 1000), progressLabel: `${Math.round(Math.min(d.totalVolumeKg, 1000))} / 1,000 kg` }),
  volume_10000: (d) => ({ unlocked: d.totalVolumeKg >= 10000, progress: Math.min(1, d.totalVolumeKg / 10000), progressLabel: `${Math.round(Math.min(d.totalVolumeKg, 10000)).toLocaleString()} / 10,000 kg` }),
  volume_100000: (d) => ({ unlocked: d.totalVolumeKg >= 100000, progress: Math.min(1, d.totalVolumeKg / 100000), progressLabel: `${Math.round(Math.min(d.totalVolumeKg, 100000)).toLocaleString()} / 100,000 kg` }),
  volume_1000000: (d) => ({ unlocked: d.totalVolumeKg >= 1000000, progress: Math.min(1, d.totalVolumeKg / 1000000), progressLabel: `${Math.round(Math.min(d.totalVolumeKg, 1000000)).toLocaleString()} / 1,000,000 kg` }),
  first_cardio: (d) => ({ unlocked: d.cardioEntries >= 1, progress: Math.min(1, d.cardioEntries / 1), progressLabel: `${Math.min(d.cardioEntries, 1)} / 1` }),
  first_weigh_in: (d) => ({ unlocked: d.bodyWeightEntries >= 1, progress: Math.min(1, d.bodyWeightEntries / 1), progressLabel: `${Math.min(d.bodyWeightEntries, 1)} / 1` }),
  lifts_100: (d) => ({ unlocked: d.liftEntries >= 100, progress: Math.min(1, d.liftEntries / 100), progressLabel: `${Math.min(d.liftEntries, 100)} / 100` }),
  lifts_500: (d) => ({ unlocked: d.liftEntries >= 500, progress: Math.min(1, d.liftEntries / 500), progressLabel: `${Math.min(d.liftEntries, 500)} / 500` }),

  // Community
  first_post: (d) => ({ unlocked: d.communityPosts >= 1, progress: Math.min(1, d.communityPosts / 1), progressLabel: `${Math.min(d.communityPosts, 1)} / 1` }),
  posts_10: (d) => ({ unlocked: d.communityPosts >= 10, progress: Math.min(1, d.communityPosts / 10), progressLabel: `${Math.min(d.communityPosts, 10)} / 10` }),
  posts_50: (d) => ({ unlocked: d.communityPosts >= 50, progress: Math.min(1, d.communityPosts / 50), progressLabel: `${Math.min(d.communityPosts, 50)} / 50` }),
  posts_100: (d) => ({ unlocked: d.communityPosts >= 100, progress: Math.min(1, d.communityPosts / 100), progressLabel: `${Math.min(d.communityPosts, 100)} / 100` }),

  // Social
  first_family: (d) => ({ unlocked: d.familyMembers >= 1, progress: Math.min(1, d.familyMembers / 1), progressLabel: `${Math.min(d.familyMembers, 1)} / 1` }),
  referral: (d) => ({ unlocked: d.hasReferral }),
  first_list: (d) => ({ unlocked: d.listCount >= 1, progress: Math.min(1, d.listCount / 1), progressLabel: `${Math.min(d.listCount, 1)} / 1` }),
  first_daily_log: (d) => ({ unlocked: d.dailyLogCount >= 1, progress: Math.min(1, d.dailyLogCount / 1), progressLabel: `${Math.min(d.dailyLogCount, 1)} / 1` }),
  daily_logs_30: (d) => ({ unlocked: d.dailyLogCount >= 30, progress: Math.min(1, d.dailyLogCount / 30), progressLabel: `${Math.min(d.dailyLogCount, 30)} / 30` }),
  daily_logs_100: (d) => ({ unlocked: d.dailyLogCount >= 100, progress: Math.min(1, d.dailyLogCount / 100), progressLabel: `${Math.min(d.dailyLogCount, 100)} / 100` }),

  // Account
  early_adopter: (d) => ({ unlocked: d.isEarlyAdopter }),
  beta_pioneer: (d) => ({ unlocked: d.isBetaTester }),
  premium: (d) => ({ unlocked: d.hasPremium }),
  theme_picker: (d) => ({ unlocked: d.hasCustomTheme }),
  custom_nav: (d) => ({ unlocked: d.hasCustomNav }),
};

// ─── Evaluate all badges against current data ────────────────────────────────

export function evaluateBadges(data: BadgeData): BadgeStatus[] {
  return BADGES.map((badge) => {
    const evaluator = EVALUATORS[badge.id];
    if (!evaluator) return { ...badge, unlocked: false };
    const result = evaluator(data);
    return { ...badge, ...result };
  });
}
